import { ScheduleOfActivities, StudyEntityType } from '@faro/study-designer-model';
import { NotFoundError } from 'faro-common-model';
import { scheduleOfActivitiesClient } from '../ScheduleOfActivities/ScheduleOfActivitiesClient';
import { studyDesignClient } from '../StudyDesign/StudyDesignClient';
import { studyPopulationClient } from '../StudyPopulation/StudyPopulationClient';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';

const type = 'pseudo.type.studydesign.scheduleofactivities';

export type StudyDesignScheduleOfActivities = {
    studyPopulationId: string;
    studyDesignId: string;
    defaultScheduleId: string;
    schedules: ScheduleOfActivities[];
};

const factory = createStudyEntityHookFactory<StudyDesignScheduleOfActivities>(type);
export const useStudyDesignerScheduleOfActivities = factory.list(
    async ({ studyId }, signal) => {
        const [population] = await studyPopulationClient.list({ studyId }, signal);
        const { id: studyPopulationId } = population;

        const design = await studyDesignClient.list({ studyId, populationId: studyPopulationId }, signal);
        if (design.length === 0) {
            throw new NotFoundError(
                `Could not find a study design for study id ${studyId} and population id ${studyPopulationId}`
            );
        }

        if (design.length > 1) {
            console.warn(
                `Found more than one study design for study id ${studyId} and population id ${studyPopulationId}`
            );
        }

        const studyDesignId = design[0].id;
        const schedules = await scheduleOfActivitiesClient.list({ studyId }, signal);

        // NOTE: Presume there will only be one study population and one schedule of activities for now
        // rendering views for multiple of each is an edge case we do not need to consider at this point
        return [
            {
                schedules,
                studyPopulationId,
                studyDesignId,
                defaultScheduleId: schedules[0].id,
            },
        ];
    },
    [StudyEntityType.StudyPopulation, StudyEntityType.StudyDesign, StudyEntityType.ScheduleOfActivities]
);
